<template>
  <div
    class="card"
    :class="[
      { 'card-lift--hover': hover },
      { shadow: shadow },
      { [`shadow-${shadowSize}`]: shadowSize },
      { [`bg-gradient-${gradient}`]: gradient },
      { [`bg-${type}`]: type },
    ]"
  >
    <slot name="image"></slot>
    <div class="card-header" :class="headerClasses" v-if="$slots.header">
      <slot name="header"> </slot>
    </div>
    <div class="card-body" :class="bodyClasses" v-if="!noBody">
      <slot></slot>
    </div>

    <slot v-if="noBody"></slot>

    <div class="card-footer" :class="footerClasses" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'card',
  props: {
    type: {
      type: String,
      description: 'Card type',
      default: '',

    },
    gradient: {
      type: String,
      description: 'Card background gradient type (warning,danger etc)',
      default: '',
    },
    hover: {
      type: Boolean,
      description: 'Whether card should move on hover',
    },
    shadow: {
      type: Boolean,
      description: 'Whether card has shadow',
    },
    shadowSize: {
      type: String,
      description: 'Card shadow size',
      default: '',

    },
    noBody: {
      type: Boolean,
      default: false,
      description: 'Whether card should have wrapper body class',
    },
    bodyClasses: {
      type: [String, Object, Array],
      description: 'Card body css classes',
      default: '',

    },
    headerClasses: {
      type: [String, Object, Array],
      description: 'Card header css classes',
      default: '',

    },
    footerClasses: {
      type: [String, Object, Array],
      description: 'Card footer css classes',
      default: '',
    },
  },
};
</script>
<style>
.card-header
{
  padding-left: 0px !important;
}

</style>
